import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { SocialMediaLink } from '@aok/ui-elements'

import defaultProps from '../../../utils/propTypes/defaultProps'
import { SocialMediaChannel } from '../../../utils/typeDefinitions/article'

import DialogOverlay from '../../molecules/Dialog/DialogOverlay'

const ArticleSharing = ({ overlayData, className }) => {
  const [overlayIsOpen, setOverlayIsOpen] = useState(false)
  // const [previousActiveElement, setPreviousActiveElement] = useState(null)
  const [selectedSocialMedia, setSelectedSocialMedia] = useState(null)

  // action for sharing on facebook
  const fbAction = () => {
    const url = 'https://www.facebook.com/sharer.php?display=popup&u=' + window.location.href
    const options = 'resizable, innerWidth=600, innerHeight=500'
    window.open(url, 'sharer', options)
  }

  const handleAction = () => {
    switch (selectedSocialMedia) {
      case SocialMediaChannel.FACEBOOK:
        fbAction()
        break
      default:
        break
    }
  }

  const showPrivacyDialog = (socialMediaChannel) => {
    setOverlayIsOpen(true)
    setSelectedSocialMedia(socialMediaChannel)
  }

  const closeDialog = () => {
    setOverlayIsOpen(false)
  }

  return (
    <div data-tracking-name="article-sharing" className={`flex justify-center gap-24 600:gap-32 ${className}`}>
      <SocialMediaLink
        type={SocialMediaChannel.FACEBOOK}
        className="shareFacebook"
        data-tracking-name="Facebook"
        onClick={() => showPrivacyDialog(SocialMediaChannel.FACEBOOK)}
      />
      <DialogOverlay
        data-social-media={selectedSocialMedia}
        data-tracking-name="T005"
        icon="speech-bubble-question"
        {...overlayData}
        actionLabel="Ich stimme zu"
        cancelLabel="Ich stimme nicht zu"
        onAction={handleAction}
        onCancel={closeDialog}
        onClose={closeDialog}
        isOpen={overlayIsOpen}
      />
    </div>
  )
}

ArticleSharing.propTypes = {
  overlayData: PropTypes.shape({
    headline: PropTypes.string,
    text: PropTypes.string,
  }),
  className: PropTypes.string,
}

ArticleSharing.defaultProps = {
  overlayData: {
    headline: defaultProps.HEADLINE,
    text: defaultProps.DESCRIPTION_RICH,
  },
  className: '',
}

export default ArticleSharing
